'use client';

import { useActiveWallet, useWallets } from '@morfi/backend-sdk-v2/client';
import { useNotifyWalletSwitched } from '@/hooks/wallet/use-notify-wallet-switched';
import { walletDisplayLabel } from './wallet-display-label';
import { WalletPickerDropdown } from './wallet-picker-dropdown';

interface DetailWalletPickerProps {
  readonly balanceLabel: string;
  readonly fallbackLabel: string;
  readonly disabled?: boolean;
  readonly valueClassName?: string;
}

/** Active-wallet switcher shared by market, winner, and proposal detail forms. */
export function DetailWalletPicker({
  balanceLabel,
  fallbackLabel,
  disabled = false,
  valueClassName,
}: DetailWalletPickerProps): React.ReactNode {
  const { activeWallet, setActiveWalletId } = useActiveWallet();
  const { wallets } = useWallets();
  const notifyWalletSwitched = useNotifyWalletSwitched();

  function handleWalletChange(walletId: string): void {
    if (walletId === activeWallet?.id) return;
    const target = wallets.find(
      (wallet) =>
        wallet.id === walletId && wallet.archivedAt === null && wallet.isAvailable !== false,
    );
    if (target === undefined) return;

    setActiveWalletId(target.id);
    notifyWalletSwitched({
      fromWalletId: activeWallet?.id ?? null,
      toWalletId: target.id,
      label: walletDisplayLabel(target),
    });
  }

  return (
    <WalletPickerDropdown
      selectedWalletId={activeWallet?.id ?? ''}
      onWalletChange={handleWalletChange}
      triggerVariant="detail-row"
      selectedValue={balanceLabel}
      fallbackLabel={fallbackLabel}
      disabled={disabled}
      align="end"
      {...(valueClassName === undefined ? {} : { valueClassName })}
    />
  );
}
